import {WaaQueryMapping, WaaValue} from './models/widget-app-assessment-v0-args.dto';

export class WaaUtils {

  static getValidValue(widgetValue: WaaValue[], data: WaaQueryMapping[]): WaaValue[] {
    const validUUID = data ? data.map(d => d.uuid) : [];
    const validValue = [];
    widgetValue?.forEach(v => {
      if (validUUID.includes(v.uuid)) {
        validValue.push(v);
      }
    });
    return validValue;
  }
}
